module.exports = __webpack_public_path__ + "frontend/img/icon_check_white.cfda0e5f.svg";